import React from 'react'
import { Form } from "react-bootstrap"
import Col from "react-bootstrap/Col"


const SelectField = ({name, required, placeholder, type, step, values, handlechange, fieldClass, label, grpmd, componentprops}) => (
  <Form.Group className={`${type} ${step}`} md={grpmd} controlId={`validation${name}`}>
    { label
      ? <Form.Label>{label}{required ? '*' : ''}</Form.Label>
      : ''

    }
    <Form.Control
		className={fieldClass}
		required={required}
		name={name}
		onChange={handlechange}
		as="select"
		value={componentprops && componentprops[name] !== undefined ? componentprops[name] : undefined}
		>
		{values.map(val =><option value={val} key={val}>{val}</option>)}
    </Form.Control>
  </Form.Group>

);

export default SelectField;